import ReplayIcon from "@mui/icons-material/Replay";
import type { FC } from "react";
import { ChatActionButton } from "./ChatActionButton";

type Props = {
	/** Accessible name + tooltip, e.g. "Regenerate". */
	label: string;
	onClick: () => void;
	dataTestId?: string;
};

/**
 * Regenerate action for a chat answer, sized for a `ChatActionBar` (which owns the row's hover/focus
 * reveal). Re-runs the question that produced the answer, replacing it.
 */
export const ChatRegenerateButton: FC<Props> = ({ label, onClick, dataTestId }) => (
	<ChatActionButton label={label} icon={<ReplayIcon />} onClick={onClick} dataTestId={dataTestId} />
);
